<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 class="mb-0">Todos los Campos</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>

        <div>
          <base-input v-model="searchQuery" placeholder="Buscar..." prepend-icon="fas fa-search"></base-input>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
        <el-table-column label="Nombre" min-width="150px" prop="name" sortable> </el-table-column>

        <el-table-column label="Productor" min-width="150px" prop="producer">
          <template #default="{ row }">
            <div>
              <router-link
                v-if="$can('show', 'producers')"
                :to="{ name: 'ProducerShow', params: { id: row.producer.id } }"
                class="h5"
              >
                {{ row.producer.businessName }}
              </router-link>
              <p v-else>{{ row.producer.businessName }}</p>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Dirección" min-width="150px" prop="address">
          <template #default="{ row }">
            <div>{{ row.address }}</div>
            <small v-if="row.city && row.city.province">{{ row.city.name }}, {{ row.city.province.name }}</small>
          </template>
        </el-table-column>

        <el-table-column label="Coordenadas" min-width="120px" prop="latitude">
          <template #default="{ row }">
            <a :href="mapLink(row)" target="_blank">{{ row.latitude }}, {{ row.longitude }}</a>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="120px">
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('show', 'fields')"
              :to="{ name: 'FieldShow', params: { id: row.id } }"
              class="btn base-button btn-outline-info btn-sm"
            >
              <i class="fas fa-eye"></i>
            </router-link>
          </div>
          <div slot-scope="{ row }" class="d-flex">
            <router-link
              v-if="$can('show', 'fields')"
              :to="{ name: 'FieldShow', params: { id: row.id } }"
              class="btn base-button btn-outline-info btn-sm"
            >
              <i class="fas fa-eye"></i>
            </router-link>
            <router-link
              v-if="$can('update', 'fields')"
              :to="{ name: 'FieldEdit', params: { id: row.id } }"
              class="btn base-button btn-outline-primary btn-sm float-left"
            >
              <i class="fas fa-pen"></i>
            </router-link>
            <button
              v-if="$can('destroy', 'fields')"
              class="btn base-button btn-outline-danger btn-sm"
              @click="deleteRow(row.id)"
            >
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ total }} campos</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        class="pagination-no-border"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { BasePagination } from '@/components';
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import PaginationMixin from '@/mixins/paginationMixin';
import DeleteRowFromTableMixin from '../../../mixins/deleteRowFromTableMixin';

export default {
  name: 'FieldsTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
  },

  mixins: [PaginationMixin, DeleteRowFromTableMixin],
  data() {
    return {
      searchKeys: ['name', 'producer.businessName', 'city.name', 'city.province.name'],
      tableData: [],
      tableName: 'FieldsTable',
    };
  },

  created() {
    this.fetchTableData();

    // configuracion para el alert de eliminar
    this.alertSettings.title = 'Se eliminará el campo';
    this.alertSuccessSettings.message = 'El campo ha sido eliminado';
    this.resourceName = 'fields';
  },

  methods: {
    mapLink(field) {
      return this.$services.resource('maps').staticPlace(field.latitude, field.longitude);
    },

    fetchTableData() {
      this.$services
        .resource('fields')
        .get({ include: ['city.province', 'producer'] })
        .then((res) => res.data.data)
        .then((data) => {
          this.tableData = data.fields;
        });
    },
  },
};
</script>

<style scoped>
div.el-table .el-table__header .cell,
::v-deep div.el-table .el-table__row .cell {
  word-break: keep-all;
}
</style>
